<div class="matero-error-wrap">
  <div class="matero-error-code">{{code}}</div>
  <h1 class="matero-error-title" *ngIf="title">{{title}}</h1>
  <p class="matero-error-message" *ngIf="message">{{message}}</p>
  <div><a mat-raised-button color="primary" routerLink="/">Back to Home</a></div>
</div>
